import { apiClient } from './client';

export const totpApi = {
  enroll: () =>
    apiClient
      .post<{ secret: string; otpauthUrl: string }>('/api/totp/enroll')
      .then((r) => r.data),
  confirm: (code: string) =>
    apiClient.post<{ ok: boolean }>('/api/totp/confirm', { code }).then((r) => r.data),
  disable: (code: string) =>
    apiClient.post('/api/totp/disable', { code }).then(() => undefined),
};
